import React from 'react';

const DiningAndLoungeSection = () => {
  const wrapperStyle = {
    backgroundImage: "url('/bbkandy/images/hotelbg/bbkandy.webp')",
    backgroundSize: "cover",
    padding: "60px 20px"
  };

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "60px"
  };

  const sectionStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "40px",
    flexWrap: "wrap"
  };

  const reverseStyle = {
    ...sectionStyle,
    flexDirection: "row-reverse"
  };

  const textBlockStyle = {
    backgroundColor: "#eeb85e",
    color: "#3a4a26",
    padding: "30px 25px",
    borderRadius: "30px",
    maxWidth: "400px",
    boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)"
  };

  const titleStyle = {
    fontSize: "26px",
    fontWeight: "bold",
    marginBottom: "12px",
    color: "#414f28"
  };

  const imageStyle = {
    maxWidth: "716px",
    maxHeight: "1300px",
    width: "100%",
    height: "auto",
    borderRadius: "20px"
  };

  const animateLeft = {
    animation: "fadeInLeft 1s ease-in-out"
  };

  const animateRight = {
    animation: "fadeInRight 1s ease-in-out"
  };

  return (
    <section style={wrapperStyle}>
      <div style={containerStyle}>
        {/* Dining Section */}
        <div style={sectionStyle}>
          <img
            style={imageStyle}
            src="/bbkandy/images/food/1-1.jpg"
            alt="Dining"
          />
          <div style={{...textBlockStyle, ...animateRight}}>
            <h3 style={{
              fontSize: "30px",
              fontWeight: 500,
              letterSpacing: "0px",
              lineHeight: 1.6,
              textTransform: "none",
              ...titleStyle
            }}>Dining</h3>
            <p style={{
              fontSize: "18px",
              fontWeight: 400,
              textTransform: "none",
            }}>
              One of the biggest benefits of having a luscious garden is the home-grown produce that's showcased in our meals. Flavours are curated with authenticity and substance.
            </p>
          </div>
        </div>

        {/* Lounge Section (reversed layout on desktop) */}
        <div style={reverseStyle}>
          <img
            style={imageStyle}
            src="/bbkandy/images/about/workspace.webp"
            alt="Lounge Areas"
          />
          <div style={{...textBlockStyle, ...animateLeft}}>
            <h3 style={{
              fontSize: "30px",
              fontWeight: 500,
              letterSpacing: "0px",
              lineHeight: 1.6,
              textTransform: "none",
              ...titleStyle
            }}>Lounge Areas</h3>
            <p style={{
              fontSize: "18px",
              fontWeight: 400,
              textTransform: "none",
            }}>
              Working on the go?
              Our multiple lounge areas have been carefully created for your convenience and enjoyment. Working has never been easier on vacation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DiningAndLoungeSection;